const state = {
 current_profile_worker_id: null,
 current_profile_tab_index: 0,
 current_row_id: null,
 
 current_edit_worker_id: null,
 
 current_new_entity_test_worker_id: null,
 current_entity_test_id: null,
 current_edit_entity_test_id: null,
 reload_entity_test: false,
 
 reload_tax_hmrc: false,
 reload_tax_mileage: false,
 
 current_new_assignment: {
  worker_id: null,
  compliance_test_id: null
 },
 
 delete_worker_id: null,
 update_worker_id: null,
 
 reload_cis: false
};

const actions = {};

const mutations = {
 CURRENT_PROFILE_WORKER_ID(state, worker_id) {
  state.current_profile_worker_id = worker_id;
 },
 CURRENT_EDIT_WORKER_ID(state, worker_id) {
  state.current_edit_worker_id = worker_id;
 },
 CURRENT_NEW_ENTITY_TEST_WORKER_ID(state, worker_id) {
  state.current_new_entity_test_worker_id = worker_id;
 },
 CURRENT_ENTITY_TEST_ID(state, id) {
  state.current_entity_test_id = id;
 },
 CURRENT_EDIT_ENTITY_TEST_ID(state, id) {
  state.current_edit_entity_test_id = id;
 },
 RELOAD_ENTITY_TEST(state, payload) {
  state.reload_entity_test = payload.action;
 },
 RELOAD_GENIUS_TAX(state, payload) {
  state.reload_tax_hmrc = payload.action;
 },
 RELOAD_TAX_MILEAGE(state, payload) {
  state.reload_tax_mileage = payload.action;
 },
 RELOAD_CIS_STATUS(state, payload) {
  state.reload_cis = payload.action;
 },
 CURRENT_NEW_ASSIGNMENT_WORKER_ID(state, payload) {
  state.current_new_assignment.worker_id = payload.worker_id;
  state.current_new_assignment.compliance_test_id = payload.compliance_test_id;
 },
 SET_WORKER_TAB_INDEX(state, tab_index) {
  state.current_profile_tab_index = tab_index
 },
 SET_WORKER_ROW_ID(state, row_id) {
  state.current_row_id = row_id;
 },
 CLEAR_WORKER_ROW_ID(state) {
  state.current_row_id = null;
 },
 
 SET_DELETE_WORKER_ID(state, payload) {
  state.delete_worker_id = payload;
 },
 SET_UPDATE_WORKER_ID(state, payload) {
  state.update_worker_id = payload;
 },
};

export default {
 state,
 actions,
 mutations
}
